<template>
  <JobsLayout no-heading class="jobs-dynamic-page">
    <template #backgroundImg>
      <header class="jobs-dynamic-page-header">
        <section v-if="isSmallScreen" class="mobile-screens" :style="backgroundMobileStyle">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <h1 v-html="pageData.title" />
        </section>
        <section v-else class="desktop-screens" :style="backgroundStyle">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <h1 v-html="pageData.title" />
        </section>
      </header>
    </template>
    <template #content>
      <DynamicPageThemeDefault :page-data="pageData" />
    </template>
  </JobsLayout>
</template>

<script>
  import { createMetaMixin } from "quasar";
  import { MetaHelpers } from "@core/helpers";
  import { JOBS_ROUTES } from "@jobs/config";
  import {
    ACTION_JOBS_RESET_SEARCH,
    ACTION_JOBS_DYNAMIC_GET_CONTENT_BY_ID,
    ACTION_JOBS_DYNAMIC_GET_CONTENT_BY_CITY_AND_QUALIF,
    ACTION_JOBS_GET_METADATA_BY_ROUTENAME,
    GETTER_JOBS_DYNAMIC_GET_CURRENT_PAGE_CONTENT,
    GETTER_JOBS_GET_CURRENT_METADATA,
    GETTER_JOBS_DYNAMIC_GET_CURRENT_PAGE_CONTENT_WITH_CITY_AND_QUALIF,
  } from "@jobs/store/types";

  import JobsLayout from "@jobs/layouts/Jobs.layout.vue";
  import DynamicPageThemeDefault from "@jobs/components/dynamic/DynamicPage.theme.default.vue";

  export default {
    name: "DynamicPage",
    components: {
      JobsLayout,
      DynamicPageThemeDefault,
    },
    async preFetch({ store, currentRoute, redirect }) {
      const slug = currentRoute.params.slug;
      const qualif = currentRoute.params.qualif;
      const params = currentRoute.params;
      if (slug && slug !== "undefined") {
        try {
          return Promise.all([
            store.dispatch(ACTION_JOBS_GET_METADATA_BY_ROUTENAME, { routeName: currentRoute.name, params }),
            store.dispatch(ACTION_JOBS_DYNAMIC_GET_CONTENT_BY_CITY_AND_QUALIF, { city: slug, qualif }),
            store.dispatch(ACTION_JOBS_DYNAMIC_GET_CONTENT_BY_ID, slug),
          ]);
        } catch (error) {
          return redirect(`${JOBS_ROUTES.public.home.path}`, 301);
        }
      } else {
        return redirect(`${JOBS_ROUTES.public.home.path}`, 301);
      }
    },
    mixins: [
      createMetaMixin(function () {
        const canonicalUrl =
          process.env.VUE_APP_SELF_URL && this.$route && this.$route.fullPath
            ? `${process.env.VUE_APP_SELF_URL}${this.$route.fullPath}`
            : this.seo.getCanonical();

        return MetaHelpers.setAutoMeta({
          title: this.pageData.getTitle(),
          description: this.pageData.metaDesc || this.pageData.getDescription(),
          type: this.seo.getType(),
          image: this.pageData.img_url,
          canonical: canonicalUrl,
        });
      }),
    ],
    beforeRouteLeave(to, from, next) {
      if (to.name !== JOBS_ROUTES.public.offer.detail.name && to.name !== JOBS_ROUTES.public.newDynamic.name) {
        // invalidate search results cache when we go to another page than detail
        this.$store.dispatch(ACTION_JOBS_RESET_SEARCH);
      }
      next();
    },

    computed: {
      pageData() {
        if (
          this.$route.params.slug &&
          this.$route.params.slug !== "undefined" &&
          this.$route.params.qualif &&
          this.$route.params.qualif !== "undefined"
        ) {
          return this.$store.getters[GETTER_JOBS_DYNAMIC_GET_CURRENT_PAGE_CONTENT_WITH_CITY_AND_QUALIF];
        } else {
          return this.$store.getters[GETTER_JOBS_DYNAMIC_GET_CURRENT_PAGE_CONTENT];
        }
      },
      seo() {
        return this.$store.getters[GETTER_JOBS_GET_CURRENT_METADATA];
      },
      backgroundStyle() {
        return {
          backgroundImage: `url("${this.pageData.img_url}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px",
        };
      },
      backgroundMobileStyle() {
        return {
          backgroundImage: `url("${this.pageData.img_url}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px",
        };
      },
      isSmallScreen() {
        return this.$q.screen.lt.md;
      },
    },
    created() {
      return this.$store.dispatch(ACTION_JOBS_DYNAMIC_GET_CONTENT_BY_CITY_AND_QUALIF, {
        city: this.$route.params.slug,
        qualif: this.$route.params.qualif,
      });
    },
  };
</script>

<style lang="scss">
  .jobs-dynamic-page {
    .jobs-dynamic-page-header {
      position: relative;
      h2 {
        font-size: 14px;
      }
      > section {
        width: 100%;
        height: 100%;
        color: white;
        padding: 0 8%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.45);
        }

        h1 {
          margin: 0;
          position: relative;
          z-index: 1;
        }
      }
    }
  }
</style>
